<script>
	import currentUserStore from "../../../stores/data/currentUserStore";
	import draftsStore from "../../../stores/data/draftsStore";

	import Fetcher from "../../../api/Fetcher";

	import Field from "../../forms/Field.svelte";

	export let topicVerification;
	export let text;
	export let draftId;

	let debounceTimer;

	$: currentUser = $currentUserStore;
	$: field = getField(topicVerification, draftId, currentUser);

	function getField(topicVerification, draftId, currentUser) {
		if (!draftId || currentUser?.settings?.postTopicVerification === "None") {
			return;
		}
		return {
			type: "input",
			inputType: "text",
			value: topicVerification,
			placeholder: "Topic Verification",
			inputClass: "input-sm",
		};
	}

	function handleChange({ detail }) {
		if (detail.type !== "input") return;
		topicVerification = detail.value;
		clearTimeout(debounceTimer);
		debounceTimer = setTimeout(() => updateDraft(detail.value), 500);
	}

	function updateDraft(topicVerification) {
		Fetcher.updateDraft({ draftId, topicVerification }).then(
			handleDraftUpdated
		);
	}

	function handleDraftUpdated() {
		draftsStore.fetchDrafts();
	}
</script>

{#if field}
	<div class="grow">
		<Field {field} on:event={handleChange} />
	</div>
{/if}
